<template>
  <window size="lg" :title="windowTitle">
    <editable
      slot-scope="window"
      :show-toggle-button="false"
      :default-state="allowEdit ? 'edit' : 'show'"
      :initial-data="message"
      :children-validation-messages="validationMessages"
      class="mt-lg"
    >
      <template slot-scope="editable">
        <div>
          <editable-list
            name="pictures"
            :icon-src="icon"
            :additional-base-classes="['job-technician-message__pictures']"
            :popups="app.layout.popups"
            :confirm-remove="true"
          >
            <template slot="itemTemplates">
              <editable-image
                :use-croppie="false"
                :src-loader="loadImageSrc"
                :choose-on-mounted="true"
              >
                <template slot="fileLabel">
                  <img :src="icon('camera.svg')" />
                </template>
              </editable-image>
            </template>

            <template slot="buttons" slot-scope="listParts" v-if="allowEdit">
              <button
                class="add-picture btn-plain"
                @click="listParts.newItem(0)"
              >
                <img
                  :src="
                    icon(
                      undefined in listParts.data &&
                        listParts.data[undefined].length
                        ? 'cross.svg'
                        : 'camera.svg'
                    )
                  "
                  :class="{
                    'mb-sm': true,
                    'icon-add':
                      undefined in listParts.data &&
                      listParts.data[undefined].length > 0,
                  }"
                />

                Foto hinzufügen
              </button>
            </template>
          </editable-list>
        </div>
        <div class="mt-lg mb-lg">
          <editable-text
            name="text"
            label="Mitteilung an den Projektleiter"
            placeholder="Beschreiben Sie das Problem, den Schaden oder das Bild"
            validation="required"
          >
          </editable-text>
        </div>
        <div class="mt-lg mb-lg">
          <editable-check
            name="triggerRepairRequest"
            label="Reparaturauftrag anstoßen"
            :icon-src="icon"
          ></editable-check>
        </div>
        <div class="buttons mb-3">
          <button class="btn btn-secondary" @click="window.hide()">
            Abbrechen
          </button>

          <button
            class="btn btn-primary"
            @click="send(editable, window)"
            :disabled="!allowEdit"
          >
            Absenden
          </button>
        </div>
      </template>
    </editable>
  </window>
</template>

<script>
import api from "../helper/api";

export default {
  provide: {
    windowId: "JobTechnicianMessagePart",
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    message: {
      type: Object,
      default() {
        return {};
      },
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      // errorImage: false,
    };
  },
  computed: {
    windowTitle() {
      return (
        (this.title ? this.title + " - " : "") + "Meldung an Projektleiter"
      );
    },
    validationMessages() {
      return {
        text: {
          required:
            "Sie müssen das Problem beschreiben, bevor Sie die Meldung abschicken können!",
        },
      };
    },
  },

  methods: {
    loadImageSrc(data) {
      if (data && typeof data == "object" && "file" in data) {
        return api.download(
          this.config.api.urls.files.download + "/" + data.file.route
        );
      }

      return Promise.resolve(data);
    },
    send(editable, window) {
      if (editable.validate(true)) {
        editable.removeEmptyChildren();
        window.hide(editable.data);
      }
    },
  },
};
</script>

<style lang="scss">
.job-technician-message {
  &__pictures {
    display: flex;
    flex-wrap: wrap;

    &__item {
      flex-direction: column;
    }
    &__item-controls {
      padding-bottom: map-get($spacers, xs);

      > button > img {
        border: 1px solid $black;
        border-radius: 50%;
        padding: map-get($spacers, xs);
      }
    }

    > .editable__element__errors {
      flex: 1 0 100%;
      width: 100%;
    }

    > ul > li,
    > .editable__element__buttons {
      width: 150px;
    }

    > ul {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 0;

      > li {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        height: 100%;

        > button {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 1;
        }

        .editable__element-image,
        .editable__element__image-container {
          position: relative;

          &,
          > img {
            width: 100%;
            height: 200px;
          }

          > img {
            object-fit: cover;
          }

          .spinner {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
          }

          .editable__element__input {
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            transform: none;
            display: flex;
            align-items: stretch;
            justify-content: stretch;

            > label {
              flex: 1 0 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }

    .add-picture {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding-top: map-get($spacers, lg);

      .icon-add {
        transform: rotate(45deg);
        width: 16px;
        height: 16px;
      }
    }
  }
}

.error-message-image {
  color: #e02020;
}
</style>